import { routeGroup } from 'routing/routes';

export const authResetPasswordRoute = routeGroup.route(
  '/reset-password/:token',
);

export const authMfaRoute = routeGroup.route('/mfa/:token');
